const padZero = (number) => number >= 10 ? number.toString() : `0${number}`;

export const secondsToTime = (seconds) => {
  return `${padZero(Math.floor(seconds / 60))}:${padZero(seconds % 60)}`;
};
